<script setup lang="ts">
import zhCn from 'element-plus/es/locale/lang/zh-cn'
</script>

<template>
  <!-- 全局 Element Plus 中文 locale：日期面板星期/月份、分页、弹窗等文案均为中文 -->
  <el-config-provider :locale="zhCn">
    <RouterView />
  </el-config-provider>
</template>
